// extracted by mini-css-extract-plugin
export default {"wrapper":"FormHeader_wrapper__66EJ3"};